import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/pt.ts
var add = "Incluir";
var remove = "Remover";
var removeAll = "Remover todos";
var incomplete = "Desculpe, alguns campos não foram preenchidos corretamente.";
var submit = "Enviar";
var noFiles = "Nenhum arquivo selecionado.";
var moveUp = "Mover para cima";
var moveDown = "Mover para baixo";
var isLoading = "Carregando...";
var loadMore = "Carregar mais";
var next = "Próximo";
var prev = "Anterior";
var addAllValues = "Adicione todos os valores";
var addSelectedValues = "Adicionar valores selecionados";
var removeAllValues = "Remover todos os valores";
var removeSelectedValues = "Remover valores selecionados";
var chooseDate = "Escolha a data";
var changeDate = "Data da alteração";
var close = "Fechar";
var open = "Aberto";
var accepted = function({
  name
}) {
  return `Por favor aceite o ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} precisa ser depois de ${date(args[0])}.`;
  }
  return `${sentence(name)} precisa ser no futuro.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} precisa conter apenas letras.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} pode conter apenas letras e números.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} pode conter apenas números e espaços.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} deve conter caracteres alfabéticos.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} deve conter letras ou números.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} deve conter letras ou espaços.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} deve conter um símbolo.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} deve conter letras maiúsculas.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} deve conter letras minúsculas.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} deve conter números.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} deve ser um símbolo.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} só pode conter letras maiúsculas.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} só pode conter letras minúsculas.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} precisa ser antes de ${date(args[0])}.`;
  }
  return `${sentence(name)} precisa ser no passado.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Este campo não foi configurado corretamente e não pode ser submetido.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} precisa ser entre ${a} e ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} não é igual.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} não é uma data válida, por favor use este formato ${args[0]}`;
  }
  return "Este campo não foi configurado corretamente e não pode ser submetido.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} precisa ser entre ${date(args[0])} e ${date(args[1])}`;
};
var email = "Por favor, insira um endereço de email válido.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} não termina com ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} não é um valor permitido.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = first <= second ? first : second;
  const max2 = second >= first ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} precisa conter ao menos um caractere.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} precisa ser menor ou igual a ${max2} caracteres.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} precisa conter ${max2} caracteres.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} precisa ser maior ou igual a ${min2} caracteres.`;
  }
  return `${sentence(name)} precisa ter entre ${min2} e ${max2} caracteres.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} não é um valor permitido.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Não pode ter mais de ${args[0]} ${name}.`;
  }
  return `${sentence(name)} precisa ser menor ou igual a ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Não há formatos de arquivos permitidos.";
  }
  return `${sentence(name)} precisa ser do tipo: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Não pode ter menos de ${args[0]} ${name}.`;
  }
  return `${sentence(name)} precisa ser pelo menos ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” não é um(a) ${name} permitido(a).`;
};
var number = function({
  name
}) {
  return `${sentence(name)} precisa ser um número.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" ou ")} é necessário.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} é obrigatório.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} não começa com ${list(args)}.`;
};
var url = function() {
  return `Por favor, insira uma url válida.`;
};
var invalidDate = "A data selecionada é inválida.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var pt_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, pt_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=pt.mjs.map